import { useMemo, useState } from "react";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { Add, HelpOutline } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import {
  HeaderRightContent,
  PageTitleSubtitle,
  StyledHeader,
} from "../Common/styles/header";
import FeaturesList from "./Tabs/FeaturesList";
import FeatureUrlLoader from "./FeatureUrlLoader";
import FeatureUrlSetter from "./FeatureUrlSetter";
import {
  a11yProps,
  CustomTabPanel,
  MainTabPanel,
  StyledTab,
  StyledTabs,
} from "../Common/UI/TabPanel";
import Permissions from "./Tabs/Permissions";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { openHelp } from "../../Redux/reducers/helpSlice";
import { platformAdminPermissions } from "../../utils/roles";
import LogoutContainer from "../Layout/LogoutContainer";

const Features = () => {
  const { t: sidebarT } = useTranslation("sidebar");
  const dispatch = useAppDispatch();
  const [showModal, setShowModal] = useState<string>("");
  const [type, setType] = useState("features");
  const [urlLoaded, setUrlLoaded] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const platformPermissions = useAppSelector(
    (state) => state.user.platformPermissions,
  );
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.managePlatform),
    [platformPermissions],
  );

  const handleChange = (_: any, newValue: string) => {
    setType(newValue);
  };
  return urlLoaded ? (
    <>
      <Box
        sx={{
          height: "64px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box>
      </Box>
      <StyledHeader>
        <PageTitleSubtitle
          title="Features"
          subtitle="Manage and monitor features."
        />
        <Box sx={HeaderRightContent}>
          {type === "features" && canEdit && (
            <Box>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => setShowModal("feature")}
              >
                New Feature
              </Button>
            </Box>
          )}
          {/* {type === "permissions" && canEdit && (
            <Box>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => setShowModal("permissions")}
              >
                Add Permission
              </Button>
            </Box>
          )} */}
          <Tooltip title={sidebarT("HELP_TOOLTIP")}>
            <IconButton onClick={() => dispatch(openHelp("features"))} size="small">
              <HelpOutline />
            </IconButton>
          </Tooltip>
        </Box>
      </StyledHeader>
      <Box sx={{ padding: "0px 40px" }}>
        <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
          <StyledTabs value={type} onChange={handleChange}>
            <StyledTab label="Features" value="features" {...a11yProps(0)} />
            <StyledTab
              label="Permissions"
              value="permissions"
              {...a11yProps(1)}
            />
          </StyledTabs>
        </Box>
      </Box>
      <Box>
        <Box
          sx={{
            height: "calc(100vh - 204px)",
            overflow: "auto",
            p: type === "permissions" ? "0px 40px" : 2.5,
          }}
        >
          <MainTabPanel value={type} index={"features"}>
            <FeaturesList
              type={type}
              showModal={showModal}
              setShowModal={setShowModal}
              canEdit={canEdit}
            />
          </MainTabPanel>

          <CustomTabPanel value={type} index={"permissions"}>
            <Permissions
              type={type}
              showModal={showModal}
              setShowModal={setShowModal}
              searchText={searchText}
              setSearchText={setSearchText}
              canEdit={canEdit}
            />
          </CustomTabPanel>
        </Box>
      </Box>
      <FeatureUrlSetter type={type} searchText={searchText} />
    </>
  ) : (
    <FeatureUrlLoader
      setType={setType}
      setSearchText={setSearchText}
      setUrlLoaded={setUrlLoaded}
    />
  );
};

export default Features;
